import React from "react";
import SafeLink from "components/commons/SafeLink";
// import {url} from "./Constants";
import axios from "axios";
import {
  shareContent,
  trackEvents
} from "helpers/insights";
import {InsightsThankYou} from "components";


class ShareFooter extends React.Component {
  constructor () {
    super();
    this.state = {
      userSubscribed: false
    };
  }

  handleClick = (event) => {
    event.preventDefault();
    const userEmailId = document.getElementById("subscribeFooterEmail").value;
    const ignorePageCallEventForClickables = true;
    axios.post("https://api.wealthy.in/v0/insights/subscribe/", {
      email: userEmailId
    })
      .then(() => {
        this.setState({userSubscribed: true});
        trackEvents(
          "User Subscribed from Content Footer",
          {email: userEmailId},
          ignorePageCallEventForClickables
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render () {
    return (
      <div className="social-share-bar">
        <div className="social-share-icons">
          <div className="share-count-info">
            <div className="share-count">{this.props.shareCount}</div>
            <div className="text">SHARES</div>
          </div>
          <div>
            <SafeLink onClick={shareContent.bind(this, "facebook")}><i className="facebook fa fa-facebook center" data-toggle="tooltip" title="Share on Facebook" /></SafeLink>
            <SafeLink onClick={shareContent.bind(this, "twitter")}><i className="twitter fa fa-twitter center" data-toggle="tooltip" title="Tweet this" /></SafeLink>
          </div>
        </div>
        <div className="social-share-subscribe">
          <form className="form-inline" onSubmit={this.handleClick}>
            { this.state.userSubscribed ?
              <InsightsThankYou message={"Thanks for Subscribing"} />
              :
              <div className="input-group">
                <input required className="form-control" id='subscribeFooterEmail' placeholder="Enter your Email.." type="email" />
                <span className="input-group-btn">
                  <button className="btn btn-default" type="submit">Subscribe</button>
                </span>
              </div>
            }
          </form>
        </div>
      </div>
    );
  }
}

export default ShareFooter;
